import React, { useId } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormField from './FormField';

function isEmptySelectValue(value) {
  return value === '' || value === null || value === undefined;
}

/**
 * Static dropdown select built on FormField — options: [{ value, label }].
 */
const FormSelect = React.forwardRef(function FormSelect(
  {
    options = [],
    placeholder,
    displayEmpty = true,
    SelectProps,
    value,
    children,
    sx,
    ...props
  },
  ref
) {
  return (
    <FormField
      ref={ref}
      select
      value={value}
      SelectProps={{
        displayEmpty,
        ...SelectProps,
      }}
      sx={{
        '& .MuiSelect-select': {
          color: isEmptySelectValue(value) ? 'text.secondary' : 'text.primary',
        },
        ...sx,
      }}
      {...props}
    >
      {placeholder ? (
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
      ) : null}
      {children ??
        options.map((option) => (
          <MenuItem key={String(option.value)} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
    </FormField>
  );
});

FormSelect.displayName = 'FormSelect';

export default FormSelect;
